import authRequest from "@/api/http/authRequest";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/offline-class-applications`, params, cb, errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/offline-class-application/${params.id}`, params ,cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/offline-class-application`, params,cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/offline-class-application/${id}`, cb, errCb)
  },
}
